module.exports = __webpack_public_path__ + "img/eoi-hero_jp.1a816d3.jpg";